import { Card, Col, Row } from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import PreviewImage from '../../../../components/molecules/PreviewImage'
import UploadFile from '../../../../components/molecules/UploadFile'
import { cardStyle } from './DcDetailStyles'

const DcDeliveryProof = ({
  proof,
  loadingDeleteDeliveryProof,
  handleDeleteImage,
  handleShowPreview,
  loadingUploadFile,
  handleImageChange
}) => {
  return (
    <Card style={cardStyle}>
      <Row className="mb-3">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h5
            className="text-secondary mb-0"
            style={{ fontSize: '1rem', fontWeight: 'bold' }}
          >
            DELIVERY PROOF
          </h5>
        </Col>
      </Row>
      <Row className="mb-3">
        <div className="d-flex flex-row flex-wrap gap-2 w-100">
          {proof.length > 0 &&
            proof.map((image, i) => (
              <PreviewImage
                key={`${image}-${i}`}
                value={image}
                loading={loadingDeleteDeliveryProof[image]}
                handleDelete={() => handleDeleteImage(image)}
                handlePreview={() =>
                  handleShowPreview(image, `Delivery Proof ${i + 1}`)
                }
              />
            ))}
          {loadingUploadFile && (
            <div
              style={{
                border: '2px solid #dee2e6',
                borderRadius: '10px',
                width: '100px',
                height: '100px',
                padding: '10px',
                cursor: 'not-allowed'
              }}
              role="button"
            >
              <div className="d-flex flex-column justify-content-center gap-2 fs-6 h-100">
                <div className="text-center">
                  <Loader />
                </div>
                <small className="text-center fw-bold">Uploading...</small>
              </div>
            </div>
          )}
          {!loadingUploadFile && (
            <UploadFile handleFileChange={handleImageChange} />
          )}
        </div>
      </Row>
    </Card>
  )
}

export default DcDeliveryProof
